<template>
  <partner-layout>
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 sm3 class="px-1">
          <multiselect
            v-model="status"
            :options="statusOptions"
            label="text"
            selectLabel
            selectedLabel
            :allow-empty="false"
            :searchable="false"
            deselect-label
            track-by="text"
          ></multiselect>
        </v-flex>
        <v-flex xs12 sm3 class="form-control px-1">
          <input type="text" v-model="search" :placeholder="$t('Search')" />
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-left text-sm-right"> </v-flex>
      </v-layout>

      <div>
        <v-data-table
          :headers="headers"
          :items="computedRedeemCode"
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.code }}</td>
            <td>
              <v-chip v-if="props.item.status" color="grey" small dark>Redeemed</v-chip>
              <v-chip v-else color="green" small dark>Available</v-chip>
            </td>
            <td>
              <template v-if="props.activatedate">{{
                props.activatedate | DateFormat('DD MMM YYYY HH:mm')
              }}</template
              ><template v-else>-</template>
            </td>
            <td>
              <template v-if="props.expiredate">{{
                props.expiredate | DateFormat('DD MMM YYYY HH:mm')
              }}</template
              ><template v-else>-</template>
            </td>
            <td>
              <template v-if="props.item.customer_media == 'facebook'">
                <em class="fab fa-facebook" style="color: #3c5a99" /> Facebook
              </template>
              <template v-else-if="props.item.customer_media == 'line'">
                <em class="fab fa-line" style="color: #00c300" /> Line
              </template>
            </td>
            <td>{{ props.item.customer_media_name ? props.item.customer_media_name : '-' }}</td>
          </template>
        </v-data-table>
      </div>
    </v-container>
  </partner-layout>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  data() {
    return {
      search: '',
      status: null,
      pagination: {
        sortBy: 'status'
      },
      statusOptions: [
        {
          text: 'All',
          value: null
        },
        {
          text: 'Redeemed',
          value: true
        },
        {
          text: 'Available',
          value: false
        }
      ],
      headers: [
        {
          text: 'Redeem Code',
          value: 'code'
        },
        {
          text: 'Status',
          value: 'status'
        },
        { text: 'Activate Date', value: 'activatedate' },
        { text: 'Expired Date', value: 'expiredate' },
        { text: 'Customer Media', value: 'customer_media' },
        { text: 'Customer Media Name', value: 'customer_media_name' }
      ],
      redeemcodes: []
    }
  },
  async mounted() {
    let response = await this.getPartnerRedeemCode()
    if (response.responsecode == 200 && response.data) {
      this.redeemcodes = response.data
    }
  },
  components: {
    Multiselect
  },
  computed: {
    computedRedeemCode() {
      var redeemcodes = [...this.redeemcodes]
      if (this.status && this.status.value != null) {
        redeemcodes = this.redeemcodes.filter((el) => {
          return el.status == this.status.value
        })
      }
      return redeemcodes.filter((el) => {
        return (
          (el.customer_media_name &&
            el.customer_media_name.toLowerCase().includes(this.search.toLowerCase())) ||
          (el.code && el.code.toLowerCase().includes(this.search.toLowerCase()))
        )
      })
    }
  },
  methods: {
    getPartnerRedeemCode() {
      var data = {
        partner_code: this.$store.state.partner_code
      }
      return new Promise((resolve, reject) => {
        api.getPartnerRedeemCode(data, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/partner/RedeemCode.vue